// extracted by mini-css-extract-plugin
export default {"advertCardPhoto":"c-a_gY","advertCardPhoto__image":"c-a_gZ"};